export const CUSTOMER_AGENT_INFO_ENUM = [
    { key: 'reportedDate', label: 'Reported Date' },
    { key: 'cbCreatedDate', label: 'Chargeback Created Date' },
    { key: 'rrnNumber', label: 'RRN No.' },
    { key: 'chagebackLevel', label: 'Chageback Level' },
    { key: 'dueDate', label: 'Due Date' },
    { key: 'reasonCode', label: 'Reason Code' },
    { key: 'reasonCodeMessage', label: 'Reason Code Message' },
    { key: 'chargebackStatus', label: 'Chargeback Status' },
    { key: 'chargebackMessage', label: 'Message' },
    { key: 'docs', label: 'Documents', component: 'DocumentView' },
];

export const CHARGEBACK_SEARCH_OPTIONS = [
    {
        label: 'Transaction ID',
        value: 'TRANSACTION_ID',
    },
];

export const MERCHANT_RESPONSE_INFO_ENUM = [
    {
        key: 'status',
        label: 'Status',
    },
    { key: 'amount', label: 'Amount' },
    { key: 'date', label: 'Date' },
    { key: 'merchantRemarks', label: 'Remarks' },
    { key: 'docs', label: 'Documents', component: 'DocumentView' },
];

export const DEFEND_TRANSACTION_INFO_ENUM = [
    { key: 'amount', label: 'Amount' },
    {
        key: 'orderId',
        label: 'Order ID',
    },
    {
        key: 'dateTime',
        label: 'Date',
    },
];

export const UPDATE_STATUS_OPTIONS = {
    SUBMITTED_TO_BANK: [
        {
            name: 'Close in customer favour',
            value: 'CLOSED_IN_CUSTOMER_FAVOUR',
            checked: false,
        },
        {
            name: 'Close in merchant favour',
            value: 'CLOSED_IN_MERCHANT_FAVOUR',
            checked: false,
        },
        {
            name: 'Insufficient Document',
            value: 'INSUFFICIENT_DOCUMENT',
            checked: false,
        },
    ],
    CLOSED_IN_CUSTOMER_FAVOUR: [],
    CLOSED_IN_MERCHANT_FAVOUR: [],
    PENDING_RESPONSE: [],
    PENDING_DOC_REVIEW: [
        {
            name: 'Submit to bank',
            value: 'SUBMITTED_TO_BANK',
            checked: false,
        },
        {
            name: 'Insufficient Document',
            value: 'INSUFFICIENT_DOCUMENT',
            checked: false,
        },
    ],
    CLOSURE_OPTIONS: [
        {
            name: 'Close in customer favour',
            value: 'CLOSED_IN_CUSTOMER_FAVOUR',
            checked: false,
        },
        {
            name: 'Close in merchant favour',
            value: 'CLOSED_IN_MERCHANT_FAVOUR',
            checked: false,
        },
    ],
};

export const UPDATE_STATUS_OPTIONS_NEW_LEVEL = {
    SUBMITTED_TO_BANK: [
        {
            name: 'Insufficient Document',
            value: 'INSUFFICIENT_DOCUMENT',
            checked: false,
        },
    ],
    CLOSED_IN_CUSTOMER_FAVOUR: [],
    CLOSED_IN_MERCHANT_FAVOUR: [],
    PENDING_RESPONSE: [
        {
            name: 'Insufficient Document',
            value: 'INSUFFICIENT_DOCUMENT',
            checked: false,
        },
        {
            name: 'Submit to bank',
            value: 'SUBMITTED_TO_BANK',
            checked: false,
        },
        {
            name: 'Close in customer favour',
            value: 'CLOSED_IN_CUSTOMER_FAVOUR',
            checked: false,
        },
    ],
    PENDING_DOC_REVIEW: [
        {
            name: 'Submit to bank',
            value: 'SUBMITTED_TO_BANK',
            checked: false,
        },
        {
            name: 'Insufficient Document',
            value: 'INSUFFICIENT_DOCUMENT',
            checked: false,
        },
    ],
};

export const DEADLINE_OPTIONS = [
    {
        name: '1 Day',
        value: 1,
        checked: false,
    },
    {
        name: '2 Days',
        value: 2,
        checked: false,
    },
    {
        name: '3 Days',
        value: 3,
        checked: false,
    },
    {
        name: '4 Days',
        value: 4,
        checked: false,
    },
];
